import { useState } from "react";
import { TextField } from "@material-ui/core";
import useValidations from "hooks/useValidations";
import { ContractRowMovementStore } from "store";
import { lang } from "i18nLang";

interface IProps {
  classes: any;
  onChangeData: (data: any) => void;
  onBlurInput: (field: string, value: any, isValid: boolean) => void;
}

const CancellationRowForm = ({
  classes,
  onChangeData,
  onBlurInput,
}: IProps) => {
  const [data, setData] = useState({
    code: "",
  });

  const { validated, validateFields } = useValidations({
    code: {
      required: true,
      custom: function (value) {
        return ContractRowMovementStore.verifyExistedCode(value);
      },
    },
  });

  const handleChangeInput = (ev) => {
    const { name, value } = ev.target;
    const newData = { ...data };
    newData[name] = value;
    setData(newData);
    onChangeData(newData);
  };

  const handleBlurInput = (ev) => {
    const { name, value } = ev.target;
    const valid = validateFields({ [name]: value });
    onBlurInput(name, value, valid);
  };

  return (
    <form style={{ width: "100%" }} onSubmit={(ev) => ev.preventDefault()}>
      <TextField
        name="code"
        label={lang("fields.code")}
        className={classes.input}
        color="secondary"
        value={data.code}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        error={!validated.code.valid}
        helperText={validated.code.text}
        fullWidth
      />
    </form>
  );
};

export default CancellationRowForm;
